import ExaminationSidebar from "../../components/sidebar/ExaminationSidebar";
import ExaminationNavbar from "../../components/navbar/ExaminationNavbar.jsx";
import "./subjectResult.scss";
import Widget from "../../components/widget/Widget";
import { useState } from "react";
import { useParams } from 'react-router-dom';
import LineCharts from "../../components/chart/LineChart";
import ExaminationCard from "../../components/card/ExaminationCard.jsx";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import StackedBarChart from "../../components/chart/StackedBarChart.jsx";
import CustomPieChart from "../../components/chart/PieChart.jsx";
import Select from "react-select";

const subjects = [
    { id: 1, subject: "Physics" },
    { id: 2, subject: "Chemistry" },
    { id: 3, subject: "Mathematics" },
    { id: 4, subject: "English" },
    { id: 5, subject: "Urdu" },
    { id: 6, subject: "Islamiat" }
];

const samplePieData = [
    { name: 'A1', value: 20 },
    { name: 'A+', value: 36 },
    { name: 'A', value: 42 },
    { name: 'B', value: 38 },
    { name: 'C', value: 25 },
    { name: 'Retry', value: 25 },
];


const generateMockResultData = (subjects = ["Math", "English"]) => {
    const names = Array.from({ length: 25 }, (_, i) => `Student ${i + 1}`);

    return names.map(name => {
        const studentData = { name };
        subjects.forEach(sub => {
            studentData[sub] = Math.floor(Math.random() * 41) + 60; // marks between 60-100
        });
        return studentData;
    });
};

// Subjects to show on bar chart (can be dynamic)
const selectedSubjectsForChart = ["Math", "English", "Physics"];
const stackedBarChartData = generateMockResultData(selectedSubjectsForChart);

const SubjectResult = () => {
    const [token] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const { courseId } = useParams();

    const course = subjects.find(subject => subject.id === parseInt(courseId)); //Finding course name

    const monthOptions = [
        { value: "All", label: "All" },
        { value: "January", label: "January" },
        { value: "February", label: "February" },
        { value: "March", label: "March" }
    ];

    const redirectToLogin = () => {
        alert("Please Login first then you can access this page...");
        window.location.href = '/';
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <>
            {!token && redirectToLogin()}
            {token && (
                <div className="subjectResult">
                    {sidebarOpen ? (
                        <ExaminationSidebar isOpen={sidebarOpen} toggle={toggleSidebar} />
                    ) : undefined}
                    <div className="homeContainer">
                        <ExaminationNavbar isOpen={sidebarOpen} toggle={toggleSidebar} />
                        <div className="heading">
                            <h2>{course ? course.subject : 'Course'}</h2>
                            <p><b>Teachers:</b> Sir Fayyaz & Sir Jawwad</p>
                        </div>
                        <div className="widgets">
                            <div className="dropdown-container">
                                <label htmlFor="monthDropdown">Month</label>
                                <Select
                                    id="monthDropdown"
                                    isMulti
                                    options={monthOptions}
                                    value={selectedMonths}
                                    onChange={setSelectedMonths}
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <ExaminationCard type={"TA Attendence"} value={"87.23 %"} icon={<PersonOutlinedIcon />} />
                            <ExaminationCard type={"Targeted Course"} value={"12.00 %"} icon={<PersonOutlinedIcon />} />
                            <ExaminationCard type={"Course Covered"} value={"12.00 %"} icon={<PersonOutlinedIcon />} />
                        </div>
                        <div className="widgets">
                            <CustomPieChart data={samplePieData} title="Grades" />
                            <LineCharts title="Class Average" />
                        </div>
                        <div className="charts">
                            <StackedBarChart title={"Results"} data={stackedBarChartData}
                                subjectKeys={selectedSubjectsForChart} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SubjectResult;